import React from "react";
import { InvoiceStatus } from "@components/invoices/InvoiceStatus";
import {
    INVOICE_STATUS_VALUES,
    readInvoiceStatusFilter,
} from "@helpers/invoiceStatusFilter";
import { EMPTY_STATUS_FILTER } from "@helpers/statusFilter";
import { CombinedStatusFilter } from "../CombinedStatusFilter/CombinedStatusFilter";
import { BaseFilterProps } from "../../lib";

export const CombinedInvoiceStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <CombinedStatusFilter
        name="invoiceStatusFilterType"
        statusFilter={readInvoiceStatusFilter(filters) ?? EMPTY_STATUS_FILTER}
        statuses={INVOICE_STATUS_VALUES}
        renderStatus={(status) => <InvoiceStatus status={status} showText />}
        onChange={(invoiceStatusFilter) =>
            onChange({
                invoiceStatusFilter,
                invoiceStatuses: undefined,
                externalInvoiceStatuses: undefined,
            })
        }
    />
);
